module.exports = __webpack_public_path__ + "static/2-88472df072a22bd689036b44b97ca8e4.jpg";